import React from "react";
import { getCouponActivePushNotificationsApi } from "../api";

export const useGetActivePushNotificationCount = (id) => {
  const [count, setCount] = React.useState(0);
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    const fetchActivePushNotificationCount = async (id) => {
      try {
        setLoading(true);
        const response = await getCouponActivePushNotificationsApi(id);
        const { success, data } = response;
        if (success) {
          setCount(data.count);
        }
      } catch (error) {
        console.error("Failed to fetch active push notification count:", error);
      } finally {
        setLoading(false);
      }
    };
    if (id) fetchActivePushNotificationCount(id);
  }, [id]);

  return { count, loading };
};
